// extracted by mini-css-extract-plugin
export default {"wrap":"Cards_wrap__HRASI","title":"Cards_title__GcOOF","cards":"Cards_cards__eJubz","card":"Cards_card__xL3cM","icon":"Cards_icon__ueQwQ","text":"Cards_text__Johod"};